import React, { useEffect, useState } from "react";
import { Table, Tag, Spin, message, Typography, Card, Button } from "antd";
import axios from "axios";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import capitalizeWords from "../../../common/formatter";
import SummaryApi from "../../../common/index";

const { Title } = Typography;

const AllSellers = () => {
  const [loading, setLoading] = useState(true);
  const [sellers, setSellers] = useState([]);

const navigate = useNavigate()

  const handleViewSeller = (seller) => {
  navigate(`/admin/dashboard/seller/${seller.id}`);
};




const handleDeleteSeller = async (sellerId) => {
  const token = localStorage.getItem("adminToken");

  try {
    const confirmDelete = window.confirm("Are you sure you want to delete this seller?");
    if (!confirmDelete) return;

    const res = await axios.delete(SummaryApi.deleteSeller(sellerId).url, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.data.success) {
      message.success("Seller deleted successfully");
      fetchSellers(); // refresh the table
    } else {
      message.error("Failed to delete seller");
    }
  } catch (err) {
    console.error("Error deleting seller:", err);
    message.error("Something went wrong while deleting seller");
  }
};



  const fetchSellers = async () => {
    const token = localStorage.getItem("adminToken");
    try {
      setLoading(true);
      const response = await axios.get(SummaryApi.getAllSellers.url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });

      if (response.data.success) {
        setSellers(response.data.data);
      } else {
        message.error("Failed to load sellers");
      }
    } catch (error) {
      console.error("Error fetching sellers:", error);
      message.error("Something went wrong while loading sellers");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSellers();
  }, []);


const BASE_URL = process.env.REACT_APP_BACKEND_URL || "http:localhost:8080"
  // ✅ Function to open document in a new tab (safely)
const handleOpenDocument = async (filePath) => {
    if (!filePath) {
      message.warning("No document available for this seller");
      return;
    }

    try {
      const token = localStorage.getItem("adminToken");
      const url = filePath.startsWith("http") ? filePath : `${BASE_URL}${filePath}`;

      // Fetch the document as a blob (to include auth header)
      const res = await axios.get(url, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      });

      const blob = new Blob([res.data], { type: res.headers["content-type"] });
      const blobUrl = window.URL.createObjectURL(blob);

      // Open in new tab using an iframe
      const newWindow = window.open();
      newWindow.document.write(`
        <html>
          <head><title>Identity Document</title></head>
          <body style="margin:0">
            <iframe src="${blobUrl}" frameborder="0" style="width:100%;height:100vh"></iframe>
          </body>
        </html>
      `);
      setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
    } catch (error) {
      console.error("Error opening document:", error);
      message.error("Unable to open document");
    }
  };

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) => index + 1,
      width: 70,
    },
    {
      title: "Store Name",
      dataIndex: "store_name",
      key: "store_name",
    render: (text) => <strong>{text ? capitalizeWords(text) : "-"}</strong>,
    },
    {
      title: "Seller Name",
      dataIndex: "name",
      key: "name",
      render: (text) => text ? capitalizeWords(text) : "-",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "GST No",
      dataIndex: "gst_no",
      key: "gst_no",
      render: (text) => text || "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color =
          status === "active"
            ? "green"
            : status === "pending"
            ? "orange"
            : "red";
        return <Tag color={color}>{status?.toUpperCase()}</Tag>;
      },
    },
    {
      title: "City",
      dataIndex: "store_city",
      key: "store_city",
    },
     {
      title: "Area / Locality",
      dataIndex: "store_area",
      key: "store_area",
      render: (text) => text || "-",
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      render: (text) => text || "-",
    },
    {
      title: "Identity Proof",
      dataIndex: "identity_proof",
      key: "identity_proof",
      render: (file) =>
        file ? (
          <Button
            type="link"
            onClick={() => handleOpenDocument(file)}
            style={{ color: "#1129ce", padding: 0 }}
          >
            View Document
          </Button>
        ) : (
          "-"
        ),
    },
    {
      title: "Registered On",
      dataIndex: "created_at",
      key: "created_at",
      render: (date) =>
        date ? new Date(date).toLocaleDateString("en-IN") : "-",
    },
    {
  title: "Actions",
  key: "actions",
  width: 120,
  render: (_, record) => (
    <div style={{ display: "flex", gap: "10px" }}>
      <Button
        type="primary"
        icon={<EyeOutlined />}
        size="small"
        onClick={() => handleViewSeller(record)}
      >
        View
      </Button>
      <Button
        type="danger"
        icon={<DeleteOutlined />}
        size="small"
        onClick={() => handleDeleteSeller(record.id)}
      >
        Delete
      </Button>
    </div>
  ),
}
  ];

  return (
    <div>
      <Card
        style={{
          margin: "20px",
          borderRadius: "12px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Title level={3} style={{ marginBottom: "20px" }}>
          All Registered Sellers
        </Title>

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <Table
            columns={columns}
            dataSource={sellers}
            rowKey="id"
            bordered
            pagination={{ pageSize: 10 }}
            scroll={{ x: true }}
          />
        )}
      </Card>
    </div>
  );
};

export default AllSellers;
